/// <reference types="@angular/localize" />

import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { config } from './app/app.config.browser';

import '@angular/common/locales/global/ja';
import '@angular/common/locales/global/ko';

dayjs.extend(isBetween);

bootstrapApplication(AppComponent, config).catch((err) => console.error(err));
